import * as ROLES from './roles'

export const TAB_USERS = 'users'
export const TAB_ADMINS = 'admins'
export const TAB_MULTI_ADMINS = 'multi-admins'

export const SCOPE_MICROACTIONS = 'microactions'

const COMMON_SUB_LINKS_TAB = [
  {
    title: 'Users',
    value: TAB_USERS,
  },
  {
    title: 'Admins',
    value: TAB_ADMINS,
  },
]

export const SUB_LINKS_TAB = {
  [ROLES.SUPER_ADMIN]: [
    ...COMMON_SUB_LINKS_TAB,
    {
      title: 'Multi Admins',
      value: TAB_MULTI_ADMINS,
    },
  ],
  [ROLES.MULTI_ADMIN]: COMMON_SUB_LINKS_TAB,
}

export const headerCells = [
  {
    field: 'avatar',
    title: '',
    sortable: false,
  },
  {
    field: 'fullName',
    title: 'Full Name',
    sortable: true,
  },
  {
    field: 'email',
    title: 'Email',
    sortable: true,
  },
  {
    field: 'currentProTrack',
    title: 'Current ProTrack',
    sortable: false,
  },
  {
    field: 'teams',
    title: 'Teams',
    sortable: false,
  },
  {
    field: 'phone',
    title: 'Phone Number',
    sortable: false,
  },
  {
    field: 'invitation',
    title: 'Invitation accepted',
    sortable: false,
  },
  {
    field: 'completedCount',
    title: 'Completed',
    sortable: true,
    centered: true,
  },
  {
    title: 'Notification Types',
    field: 'notificationTypes',
    right: true,
  },
  {
    title: '',
    field: 'actions',
    right: true,
  },
]
